



















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { timeSince } from '@/utils/time'
import { Action } from 'vuex-class'
import { IMessage, IRecipient } from '@/entities/notices'
import AvatarOrInitials from '@/components/WebView/AvatarOrInitials.vue'
import { UserDetail } from '@/entities'
import TextWithHighlight from '@/components/TextWithHighlight.vue'
import AlertDialog from '@/components/AlertDialog.vue'
import NoticeTypeBadge from './NoticeTypeBadge.vue'
import { NOTICE_REACTION_TYPES } from '@/entities/notices'

@Component<NoticeRow>({
    components: {
        AlertDialog,
        AvatarOrInitials,
        TextWithHighlight,
        NoticeTypeBadge
    },
    filters: {
        timeSince
    }
})
export default class NoticeRow extends Vue {
    @Prop(Object) private message!: IMessage
    @Prop(String) private mailbox!: 'sent' | 'received' | 'scheduled'
    @Prop(Array) private recipients!: IRecipient[] // all possible users

    @Action private loadMessagesReceived
    @Action private deleteMessage

    private showCancelConfirmation = false

    private get time() {
        return this.message.created
    }

    public get userForAvatar(): UserDetail | null {
        return this.message.sender || null
    }

    private get messageText() {
        return this.message.message
    }

    private get isSeen() {
        if (this.mailbox !== 'received') {
            return false
        }
        // handle `unseen` status only in `received` tab
        return this.mailbox === 'received' && this.message.seen
    }

    private get shouldHighlightMention()
    {
        if (this.message.type === 'report') {
            return false
        }
        return true
    }

    public get highlights() {
        if (!this.shouldHighlightMention) {
            return []
        }
        return this.recipients.map((user) => `@${user.name}`)
    }

    private toggleCancel() {
        this.showCancelConfirmation = !this.showCancelConfirmation
    }

    private doCancel() {
        this.deleteMessage(this.message.id)
        this.toggleCancel()
    }

    private get emojiCount() {
        let emojiCount = 0
        for (let reactionKey in NOTICE_REACTION_TYPES) {
            emojiCount += this.message.actions[reactionKey]
        }
        return emojiCount
    }

    private get feedbackCount() {
        return this.message.actions['feedback']
    }

    private get emojiReactions() {
        let reactions = ''
        for (let actionsKey in this.message.actions) {
            if (this.message.actions[actionsKey] && NOTICE_REACTION_TYPES[actionsKey] !== undefined) {
                reactions += NOTICE_REACTION_TYPES[actionsKey] + ' '
            }
        }

        return reactions
    }
}
